import React, { useState, useEffect } from 'react';
import { useAppData } from './context/DataContext';
import { useAnalytics } from './context/AnalyticsContext';
import axios from 'axios';

import { Link, useNavigate, useLocation } from "react-router-dom";
import Navbar from './Navbar';
import Footer from './Footer';
import HomeCard from './HomeCard';
import HeroEventCarousel from './HeroEventCarousel';
import './Events';
import Signin from './Signin';
import AddCard from './AddCard';
import Ummahfy from './Ummahfy.svg';
import { ReactComponent as UmmahfyLogo } from './Ummahfy Mobile Logo.svg';
import OrganizerNavbar from './OrganizerNavbar.js';
import PhonePromptContent from './components/PhonePromptContent';
import { getEventFixtureDebugInfo } from './information.service';

import { Modal, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

function Home() {

  

  const {
    information,
    loggedInUser,
    userLoc,
    selectedOrganizationInfo
  } = useAppData();

  const analytics = useAnalytics();

  const [showingNearUser, setShowingNearUser] = useState(userLoc?.locationAllowed)
  const [info, setInfo] = useState([]);
  const [homeEventLimit, setHomeEventLimit] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 550px)').matches
      ? 4
      : 8
  );
  const [buttonSignin, setButtonSignin] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(loggedInUser?.data ? loggedInUser.data : null);
  const location = useLocation();
  
  // Add state for phone number modal
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  
  // Add organization state and fetching
  const [organizations, setOrganizations] = useState([]);
  const [organizationsLoading, setOrganizationsLoading] = useState(true);
  const fixtureDebug = getEventFixtureDebugInfo();
  
  const secrets = require("./secrets.js");
  const api = secrets.server_url;

  // Function to fetch all organizations
  async function getAllOrganizations() {
    try {
      const response = await axios.get(`${api}organizations/`, {
        headers: {
          "x-api-key": process.env.REACT_APP_UMMAHFY_API_KEY,
        },
      });
      if (response && response.data && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching organizations:", error);
      return [];
    }
  }

  // Function to find matching organization by name
  function findMatchingOrg(orgName, orgsList) {
    if (!orgName || !orgsList || orgsList.length === 0) return null;
    
    return orgsList.find(org => 
      org.name && org.name.toLowerCase() === orgName.toLowerCase()
    ) || null;
  }

  // Fetch organizations once on component mount
  useEffect(() => {
    async function fetchOrganizations() {
      try {
        setOrganizationsLoading(true);
        const orgsData = await getAllOrganizations();
        setOrganizations(orgsData);
        setOrganizationsLoading(false);
      } catch (error) {
        console.error("Error fetching organizations:", error);
        setOrganizationsLoading(false);
      }
    }

    fetchOrganizations();
  }, []);

  // Handle filtering events based on location
  useEffect(() => {
    // console.log("updated state")
    // console.log(information.length+" events")
    if (userLoc?.locationAllowed && information.length > 0) {
      const infoWithinRad = information.filter(
        (item) => item.location && item.distanceFromUser < 25
      );
      if (infoWithinRad.length >= 4) {
        setInfo(infoWithinRad);
        setShowingNearUser(true);
      } else {
        setInfo(information);
        setShowingNearUser(false);
      }
    } else {
      setInfo(information);
      setShowingNearUser(false);
    }
  }, [information, userLoc]);

  // Show fewer event cards on narrow viewports (matches CSS breakpoint ~550px).
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 550px)');
    const apply = () => setHomeEventLimit(mq.matches ? 4 : 8);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  // Show signin modal if redirected from quiz with showSignin state
  // Also check if user needs to add phone number after quiz completion
  useEffect(() => {
    if (location.state?.showSignin) {
      setButtonSignin(true);
      // Clear the state to prevent showing the modal on page refresh
      window.history.replaceState({}, document.title);
    }
    
    // Check if we need to show the phone number prompt
    // This will happen when a user completes the quiz and is redirected to the homepage
    if (location.state?.fromQuiz && user && !user.phoneNumber) {
      setShowPhoneModal(true);
      // Clear the state to prevent showing the modal on page refresh
      window.history.replaceState({}, document.title);
    }
  }, [location, user]);

  // Handle closing the phone modal
  const handlePhoneModalClose = () => {
    setShowPhoneModal(false);
  };

  console.log("check for information here",information)
  

  function createCard(info) {
    // Find matching organization for this event
    const matchedOrg = findMatchingOrg(info.organization, organizations);
    
    return (
      
      <Link
        key={info.event_id}
        to={`/event/${info.event_id}`}
        className="card-link"
        style={{ textDecoration: "none" }}
      >
        <HomeCard
          imgurl={info.img}
          event={info.name}
          masjid={info.organization}
          matchedOrg={matchedOrg}
          organizationsLoading={organizationsLoading}
          date={info.timeArray[0]}
          tags={info.tags}
          age={info.age_range}
          frequency={info.frequency}
          price={info.price}
          gender={info.gender}
          altdate={
            info.dateIndex === -1 ? info.dates[0] : info.dates[info.dateIndex]
          }
          time={info.start_datetime}

          //time={info.time}
        />
      </Link>
    );
  }

  // Track button clicks in the hero section
  const handleJoinButtonClick = () => {
    analytics.trackHomeButtonClick('join_button', 'Join Ummahfy', 'hero', {
      location: 'top_hero',
      userLoggedIn: !!user
    });
    setButtonSignin(true);
  };

  const handleQuizButtonClick = () => {
    analytics.trackHomeButtonClick('quiz_button', 'Take the Quiz', 'hero', {
      location: 'top_hero',
      userLoggedIn: !!user
    });
  };

  const handleCreateEventButtonClick = () => {
    analytics.trackHomeButtonClick('create_event_button', 'Create an Event', 'hero', {
      location: 'top_hero',
      userLoggedIn: !!user
    });
  };

  // "Create an Org" CTA: route logged-in users straight to event creation,
  // open the signin modal for guests (there is no /signin page).
  const handleCreateOrgClick = () => {
    if (user) {
      handleCreateEventButtonClick();
      navigate('/newCreateEvent');
    } else {
      handleJoinButtonClick();
    }
  };

  // Track button clicks in the quran section
  const handleQuranJoinButtonClick = () => {
    analytics.trackHomeButtonClick('join_button', 'Join Ummahfy', 'quran', {
      location: 'quran_section',
      userLoggedIn: !!user
    });
    setButtonSignin(true);
  };

  const handleSeeAllButtonClick = () => {
    analytics.trackHomeButtonClick('see_all_button', 'See All Events', 'events', {
      location: 'events_section',
      userLoggedIn: !!user
    });
  };

  // Track Add Card clicks
  const handleAddCardClick = () => {
    analytics.trackHomeButtonClick('host_event_card', 'Host Your Own Event', 'add_cards', {
      userLoggedIn: !!user
    });

    if (user) {
      navigate('/newCreateEvent');
    } else {
      setButtonSignin(true);
    }
  };

  const handleAddOrgCardClick = () => {
    analytics.trackHomeButtonClick('add_organization_card', 'Add Your Organization', 'add_cards', {
      userLoggedIn: !!user
    });
  };

  return (
    <>
      <Signin trigger={buttonSignin} setTrigger={setButtonSignin} />
      <div className="wrapper">

        <Navbar />

        {/* Add phone number modal */}
        <Modal
          title="Enable Event Reminders"
          open={showPhoneModal}
          onCancel={handlePhoneModalClose}
          footer={null}
          centered
          width={450}
        >
          <PhonePromptContent onClose={handlePhoneModalClose} />
        </Modal>

        <div class="hero">
          <div className="home-text-group">
            {user && (
              <p className="hero-trust hero-trust-top">
                Curated by the community &middot; Trusted by 20,000+ Muslims
              </p>
            )}
            {!user && (
              <p className="hero-trust hero-trust-top">
               Curated by the community &middot; Trusted by 20,000+ Muslims
              </p>
            )}
            <p class="home-title">
              Curated Muslim events.<br />Discover what&apos;s near you.
            </p>
            <p className="subtext home-hero-body">
            Browse halaqas, fundraisers, youth events, and more from masjids and organizations across your city, all in one place.
            </p>

            <div className="hero-actions">
              <Link
                to="/events"
                onClick={handleSeeAllButtonClick}
                className="hero-actions-primary-link"
              >
                <Button className="join hero-cta-primary" type="primary">
                  Find Events
                </Button>
              </Link>
              <Button
                className="join hero-cta-secondary"
                onClick={handleCreateOrgClick}
              >
                Host an Event
              </Button>
            </div>
            {!user && <Signin trigger={buttonSignin} setTrigger={setButtonSignin} />}
          </div>
          {/* Live event carousel replaces the static hero image; on mobile
              this hides via existing .hero-ummahfy-placeholder rules
              repurposed with .hero-carousel-mount. */}
          <div className="hero-carousel-mount">
            {info && info.length > 0 ? (
              <HeroEventCarousel
                events={info}
                matchedOrgFor={(orgName) =>
                  findMatchingOrg(orgName, organizations)
                }
              />
            ) : (
              <img
                src={Ummahfy}
                alt="Ummahfy"
                className="hero-ummahfy-placeholder"
              />
            )}
          </div>
        </div>

        <div class="upcoming-wrapper">
          {showingNearUser ? (
            <p class="upcoming">Events Near {userLoc.city} </p>

          ) : (
            <p class="upcoming"> Upcoming Events </p>
          )}
          <Button 
            // className="see-all" 
            className="see-all"
            icon={<EyeOutlined />}
            onClick={() => {
              handleSeeAllButtonClick();
              navigate('/events');
            }}
          >
            See All Events
          </Button>
        </div>

        <div class="grid-container">{info.slice(0, homeEventLimit).map(createCard)}</div>

        {/* <div class="quran-div">
          <div class="quote-buttons">
            <h1 class="quran-text" >
              "And hold firmly to the rope of Allah all together, and do not become divided..." (Quran 3:103) </h1>
            <div class="quran-btn-group">
              <Button className="join quran-join" onClick={handleQuranJoinButtonClick}> Join Ummahfy</Button>
              <Signin trigger={buttonSignin} setTrigger={setButtonSignin}> </Signin>
              <Button 
                // className="see-all quran-see-all" 
                onClick={() => {
                  handleSeeAllButtonClick();
                  navigate('/events');
                }}
              >
                See All Events
              </Button>

            </div>
          </div>

        </div> */}

        <div>
          <div class="want-more">
            {/* <h1 > Want more on Ummahfy? </h1>


            <div class="add-cards">
              <div onClick={handleAddCardClick}>
                <AddCard
                  title="Host Your Own Event"
                  description="Whether you're a Masjid, Muslim organization, or somebody with an idea, you can create an event!"
                  tagline="Create an event"
                  target=""
                />
              </div>


              <a 
                href="https://docs.google.com/forms/d/e/1FAIpQLSdFUSbT1Tik4sonyhxeSS_dr8UqbcOKcyDREwjLqMD5iFu9iA/viewform" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={handleAddOrgCardClick}
              >
                <AddCard
                  link="https://docs.google.com/forms/d/e/1FAIpQLSdFUSbT1Tik4sonyhxeSS_dr8UqbcOKcyDREwjLqMD5iFu9iA/viewform"
                  title="Add Your Organization"
                  description="If you want to see your local Masjid or Muslim Organization on Ummahfy, fill out this form!"
                  tagline="Request an Organization"
                  target="_blank"
                />
              </a>

            </div> */}



          </div>
        </div>

        {fixtureDebug.enabled && (
          <div
            className="fixture-debug-banner"
            style={{
              width: '100%',
              marginTop: '24px',
              marginBottom: '8px',
              padding: '8px 12px',
              borderRadius: '8px',
              background: 'rgba(37, 99, 235, 0.15)',
              border: '1px solid rgba(147, 197, 253, 0.4)',
              color: '#dbeafe',
              fontSize: '12px'
            }}
          >
            Fixture mode on | snapshot: {fixtureDebug.count} events | generated:{' '}
            {fixtureDebug.generatedAt
              ? new Date(fixtureDebug.generatedAt).toLocaleString()
              : 'unknown'}{' '}
            {fixtureDebug.source ? `| source: ${fixtureDebug.source}` : ''}
          </div>
        )}
      </div>
      <Footer> </Footer>
    </>
  );
}

export default Home;
